/**
 * Who should approve a library item, as the server resolved it: the previous approvers or the
 * template of the previous round, else the document owner or the members of its owner role.
 *
 * The frontend does not re-derive this. The same answer serves the library approval panel, the audit
 * publish flow and the public API, so the rule exists in one place (ApprovalManager on the server).
 */
export default class ApprovalResolve {
  linkId: number;

  userIds: string[];

  templateId: number | undefined;

  source: ApprovalSource;

  /** The concept approval this round supersedes: it is deleted once the new round exists. */
  conceptTaskId: number | undefined;

  /** The template runs a workflow that picks the approvers, so an empty userIds is not a gap. */
  hasWorkflowTemplate: boolean;

  constructor() {
    this.linkId = 0;
    this.userIds = [];
    this.source = ApprovalSource.None;
    this.hasWorkflowTemplate = false;
  }
}

export enum ApprovalSource {
  None = 'none',
  PreviousApproval = 'previousApproval',
  Template = 'template',
  Owner = 'owner',
  OwnerRole = 'ownerRole',
}
